import { cn } from 'helpers/css';
import React, { useMemo } from 'react';
import { ScrollArea } from 'shadcn/components/scroll-area';

const TimePicker = ({ hour, minute, onClickHour, onClickMinute }) => {
  //! State

  //! Function
  const hours = useMemo(() => {
    return Array.from({ length: 24 }, (_, i) => {})
      .map((_, i) => {
        return i;
      })
      .sort((a, b) => b - a);
  }, []);

  const minutes = useMemo(() => {
    return Array.from({ length: 60 }, (_, i) => {})
      .map((_, i) => {
        return i;
      })
      .sort((a, b) => b - a);
  }, []);

  const eachItemCls =
    'tw-cursor-pointer tw-shrink-0 tw-w-[36px] tw-h-[36px] tw-rounded-md tw-flex tw-items-center tw-justify-center';

  //! Render
  return (
    <div className='component:TimePicker tw-flex'>
      <ScrollArea className='tw-flex tw-flex-col tw-h-[300px] tw-border-r tw-p-2'>
        {hours.map((h) => (
          <div
            key={`${h}`}
            className={cn(
              eachItemCls,
              parseFloat(hour) === parseFloat(h)
                ? 'tw-bg-primary tw-text-primary-foreground'
                : 'hover:tw-bg-accent hover:tw-text-accent-foreground'
            )}
            onClick={() => {
              onClickHour && onClickHour(h);
            }}
          >
            {h}
          </div>
        ))}
      </ScrollArea>

      <ScrollArea className='tw-flex tw-flex-col tw-h-[300px] tw-p-2'>
        {minutes.map((m) => (
          <div
            key={`${m}`}
            className={cn(
              eachItemCls,
              parseFloat(minute) === parseFloat(m)
                ? 'tw-bg-primary tw-text-primary-foreground'
                : 'hover:tw-bg-accent hover:tw-text-accent-foreground'
            )}
            onClick={() => {
              onClickMinute && onClickMinute(m);
            }}
          >
            {m}
          </div>
        ))}
      </ScrollArea>
    </div>
  );
};

export default TimePicker;
